'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errors = require('../errors.js');

function hasWithFallback(_x, _x2, _x3) {
  return _hasWithFallback.apply(this, arguments);
}

function _hasWithFallback() {
  _hasWithFallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, has, store) {
    var result, levelJs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return has(key);

          case 2:
            result = _context.sent;

            if (!result) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", result);

          case 5:
            levelJs = findLevelJs(store);

            if (levelJs) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", false);

          case 8:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var req = levelJs.store('readonly').get(key.toString());

              req.transaction.onabort = function () {
                reject(req.transaction.error);
              };

              req.transaction.oncomplete = function () {
                resolve(Boolean(req.result));
              };
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _hasWithFallback.apply(this, arguments);
}

function getWithFallback(_x4, _x5, _x6, _x7) {
  return _getWithFallback.apply(this, arguments);
}

function _getWithFallback() {
  _getWithFallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key, get, has, store) {
    var levelJs;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return has(key);

          case 2:
            if (!_context2.sent) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", get(key));

          case 4:
            levelJs = findLevelJs(store);

            if (levelJs) {
              _context2.next = 7;
              break;
            }

            throw new errors.NotFoundError();

          case 7:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              var req = levelJs.store('readonly').get(key.toString());

              req.transaction.onabort = function () {
                reject(req.transaction.error);
              };

              req.transaction.oncomplete = function () {
                if (req.result) {
                  return resolve(req.result);
                }

                reject(new errors.NotFoundError());
              };
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getWithFallback.apply(this, arguments);
}

function findLevelJs(store) {
  var db = store;

  while (db.db || db.child) {
    db = db.db || db.child;

    if (db.type === 'level-js' || db.constructor.name === 'Level') {
      return db;
    }
  }
}

exports.getWithFallback = getWithFallback;
exports.hasWithFallback = hasWithFallback;